// Intent: isolate WHERE the long-lived refresh token lives so the rest of the app
// never cares. The refresh token is the key to the account (60 days), so on a
// real device it sits in the platform keychain via expo-secure-store; the dev-only
// web preview falls back to the DocStore kv (localStorage) — same pattern as the
// notifications module: Platform guard + dynamic import keeps web bundling safe.

import { Platform } from 'react-native';

import { getDb } from '@/db';

const KV_REFRESH_TOKEN = 'auth_refresh_token';
const SECURE_KEY = 'opiekun_refresh_token';

export async function saveRefreshToken(token: string): Promise<void> {
  if (Platform.OS === 'web') {
    const db = await getDb();
    await db.setKv(KV_REFRESH_TOKEN, token);
    return;
  }
  const SecureStore = await import('expo-secure-store');
  await SecureStore.setItemAsync(SECURE_KEY, token);
}

export async function getRefreshToken(): Promise<string | null> {
  if (Platform.OS === 'web') {
    const db = await getDb();
    return db.getKv(KV_REFRESH_TOKEN);
  }
  const SecureStore = await import('expo-secure-store');
  return SecureStore.getItemAsync(SECURE_KEY);
}

export async function clearRefreshToken(): Promise<void> {
  if (Platform.OS === 'web') {
    const db = await getDb();
    await db.setKv(KV_REFRESH_TOKEN, '');
    return;
  }
  const SecureStore = await import('expo-secure-store');
  await SecureStore.deleteItemAsync(SECURE_KEY);
}
